import React, { useState } from "react";
import styles from '../styles/Service.module.css';
import { HiOutlineArrowSmRight } from "react-icons/hi";

const Service = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [moreClick, setMoreClick] = useState(false);

    const pub = process.env.PUBLIC_URL;

    const titles = [
        "BNPL",
        "MARKETING",
        "ERP PLATFORM",
        "ADDITIONAL",
    ]

    const tboxs = [
        ["소비 트렌드의 새로운 발견", "BNPL 서비스"],
        ["A to Z의 혁신적인 아이디어 경쟁", "마케팅 서비스"],
        ["기술 인프라 구축의 또 다른 발전", "ERP 플랫폼"],
        ["성장을 지원하는 전략적인 파트너", "부가서비스"]
    ]

    const images = [
        `${pub}/main/5p/5p-BNPL.png`,
        `${pub}/main/5p/5p-마케팅.png`,
        `${pub}/main/5p/5p-ERP.png`,
        `${pub}/main/5p/5p-부가서비스.png`,
    ];

    const handleClick = (index) => {
        setMoreClick(false);
        setActiveIndex(index);
    }

    const handleMoreClick = (index, moreClick) => {
        if(moreClick)
            setMoreClick(false);
        else
            setMoreClick(true);

        console.log(moreClick);
    }

    return (
        <div id={styles[`service`]} className={`${styles.fpSection} ${styles.fpTable}`}>  
            <div className={styles.fpTableCell}>
                <div className={`${styles.basicIn}`}>
                    <div className={styles.imgArea}>
                        {images.map((image, index) => (
                        <div key={`image ${index}`} 
                            className={`${styles.roll} ${activeIndex === index ? styles.active : ''}` }>
                            <div className={`${styles.cover} ${moreClick === false ? '' : styles.click}`} style={{backgroundImage: `url(${image})`}}></div>
                            <div key={`text ${index}`} className={`${styles.tbox} ${moreClick === false ? '' : styles.click}`}>
                                <p>{tboxs[index][0]}</p>
                                <h4>{tboxs[index][1]}</h4>
                                <a href="#!" onClick={() => handleMoreClick(index, false)} className={styles.moreBtn}>
                                    사업소개 더보기
                                    <HiOutlineArrowSmRight size={30}/>
                                </a>
                            </div>
                            <div key={`textBox ${index}`} className={`${styles.textBox} ${moreClick === false ? '' : styles.click}`}>
                                <div className={styles.button}><button onClick={() => handleClick(index, true)}>X</button></div>
                                { index === 0 && 
                                    <>
                                        <img className={styles.dot} src={`${process.env.PUBLIC_URL}/main/5p/quote.png`} alt="쉼표"/>
                                        <span>BNPL 서비스</span>

                                        <p>(주)오퍼그룹이 물품대금을 공급사에 전액 지불한 뒤</p>
                                        <p>고객사는 (주)오퍼그룹에 분할 납부하는 서비스</p>

                                        <img className={styles.firstImg} src={`${process.env.PUBLIC_URL}/main/5p/BNPL.png`} alt="BNPL" />
                                    </>
                                }
                                 { index === 1 && 
                                    <>
                                        <img className={styles.dot} src={`${process.env.PUBLIC_URL}/main/5p/quote.png`} alt="쉼표"/>
                                        <span>마케팅 서비스</span>

                                        <p>콘텐츠 제작 / SNS 홍보 / 리뷰 모니터링 /</p>
                                        <p>숏폼 제작 / 3D 영상 미디어 제작 / 브랜드 마케팅 등</p>
                                        <p>기획부터 실행까지 맞춤형으로 서비스를 제공하여</p>
                                        <p>다양한 활동과 전략으로 고객의 목표를 충족시키는 서비스</p>

                                        <div className={styles.imgGrid}>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅01.png`} alt="마케팅" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅02.png`} alt="마케팅" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅03.png`} alt="마케팅" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅04.png`} alt="마케팅" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅05.png`} alt="마케팅" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.secondImg} src={`${process.env.PUBLIC_URL}/main/5p/마케팅06.png`} alt="마케팅" />
                                            </div>
                                        </div>
                                    </>
                                }
                                 { index === 2 && 
                                    <>
                                        <img className={styles.dot} src={`${process.env.PUBLIC_URL}/main/5p/quote.png`} alt="쉼표"/>
                                        <span>ERP 플랫폼</span>

                                        <p>재고 / 생산 / 회계 / 영업 / 급여 / 그룹웨어 등</p>
                                        <p>업무관리에 필요한 모든 기능을 제공하는</p>
                                        <p>클라우드 기반의 ERP 프로그램</p>

                                        <img className={styles.thirdImg} src={`${process.env.PUBLIC_URL}/main/5p/ERP사진.png`} alt="ERP" />
                                    </>
                                }
                                 { index === 3 && 
                                    <>
                                        <img className={styles.dot} src={`${process.env.PUBLIC_URL}/main/5p/quote.png`} alt="쉼표"/>
                                        <span>부가서비스</span>

                                        <p>보험 / 통신 / 정책자금 / 정부지원금 등의</p>
                                        <p>부가서비스를 제공하여</p>
                                        <p>개인 그리고 기업 사업자의 불필요한 금액을 절감시키며</p>
                                        <p>안정적이고 빠른 성장 방향성을 지원하는 서비스</p>

                                        <div className={styles.imgGrid2}>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.fourthImg} src={`${process.env.PUBLIC_URL}/main/5p/부가서비스01.png`} alt="부가서비스" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.fourthImg} src={`${process.env.PUBLIC_URL}/main/5p/부가서비스02.png`} alt="부가서비스" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.fourthImg} src={`${process.env.PUBLIC_URL}/main/5p/부가서비스03.png`} alt="부가서비스" />
                                            </div>
                                            <div className={styles.imgContainer}>
                                                <img className={styles.fourthImg} src={`${process.env.PUBLIC_URL}/main/5p/부가서비스04.png`} alt="부가서비스" />
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        ))}
                    </div>  
                    <div className={styles.textArea}>
                        <div className={styles.mainArea}>
                            <span className={styles.mainContent}>{titles[activeIndex]}</span>
                            <h2 className={styles.mainTitle}>서비스 소개</h2>
                        </div>
                        <span className={styles.backTitle}>BUSINESS</span>
                        <h4 className={styles.content}>
                            소상공인, 자영업자, 개인, 기업에게 <br/>
                            더 나은 일상을 제공하는 <span>가치있는 서비스</span>
                        </h4>
                        <ul>
                            {tboxs.map((text, index) => (
                                <li key={`list ${index}`} 
                                    onClick={() => handleClick(index)}
                                    className={activeIndex === index ? styles.up : null}>
                                    {text[1]}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Service;